import { render, staticRenderFns } from "./Tile.vue?vue&type=template&id=f386f08c&scoped=true&lang=pug&"
import script from "./Tile.vue?vue&type=script&lang=js&"
export * from "./Tile.vue?vue&type=script&lang=js&"
import style0 from "./Tile.vue?vue&type=style&index=0&id=f386f08c&prod&lang=stylus&scoped=true&"
import style1 from "./Tile.vue?vue&type=style&index=1&id=f386f08c&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f386f08c",
  null
  
)

export default component.exports